interface TitleProps {
  children: React.ReactNode;
}
export default function Title({ children }: TitleProps) {
  return (
    <div className="border-b pb-2 mb-4">
      <h1 className="text-4xl font-extrabold">{children}</h1>
    </div>
  );
}
